import { useSelector, shallowEqual } from 'react-redux';
import { getUserCoupons } from '../selectors';

export const useCouponsFacade = () => useSelector(getUserCoupons, shallowEqual);
